<template>
  <div style="width: 100%;">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :dfDefinitionCode="dfDefinitionCode"
      :disabled="disabled"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <PageHeader
        ref="header"
        slot="header"
        :dfDefinitionCategoryCode="dfDefinitionCategoryCode"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <EditForm
      :visible.sync="visible"
      :dfDefinitionCode="dfDefinitionCode"
      :dfDefinitionCategoryCode="dfDefinitionCategoryCode"
      :dfDefinitionItemCode="dfDefinitionItemCode"
      :disabled="disabled"
      @reload="reload"
    ></EditForm>
  </div>
</template>
<script>
import PageHeader from "./header";
import PageMain from "./main.vue";
import BaseTable from "@/mixins/base-table";
import EditForm from "../edit-form";
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, EditForm },
  props: {
    dfDefinitionCode: { type: String, default: "" },
    dfDefinitionCategoryCode: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { usePage: true, dfDefinitionItemCode: "", visible: false };
  },
  methods: {
    getData(form) {
      if (!form?.dfDefinitionCategoryCode) return;
      this.loading = true;
      this.$api
        .dfsDfDefinitionItemListApi({
          ...form,
          ...this.page,
          dfDefinitionCode: this.dfDefinitionCode,
        })
        .then((res) => {
          this.loading = false;
          this.setData(res);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openEditPage(code) {
      this.dfDefinitionItemCode = code;
      this.visible = true;
    },
  },
};
</script>
